import './Footer.css';

export default function Footer() {
  return (
    <div className='footer'>
      <p>
        Apps and website design by{' '}
        <a href='https://github.com/austinpeel'>Austin Peel</a> © 2022
      </p>
    </div>
  );
}
